module.exports = __webpack_public_path__ + "img/programme_funeng_bg2@3x.a546d86f.png";